import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { PermissionService } from 'src/app/_service/permission.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/_models/user';
import { UserService } from 'src/app/_service/user.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { UsersComponent } from '../users.component';
import { AuthService } from 'src/app/_service/auth.service';

@Component({
  selector: 'user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.css']
})
export class UserPermissionComponent implements OnInit {

  constructor(
  private userPermission: PermissionService,
  private alertify: AlertifyService,
  private dialog: MatDialog,
  private authService: AuthService,
  @Inject(MAT_DIALOG_DATA) public passedData: any) { }
  // @ViewChild(UsersComponent) userTable: UsersComponent;

  user: User;
  roles;
  role;
  roleName;
  model: any = {};
  selectedValue: string;
  displaySelectedRole: any;
  userRoleExists: any = [];
  userLocationCount: any = {};
  genericAccountRestrictedRole: any = [];
  // confirmModal = true;
  confirmModal = false;

  closeWindows = false;
  userEmailAddress = this.passedData.user.emailAddress;
  permission = this.passedData.user.permissions;

  ngOnInit() {
    this.userPermission.getRoles().subscribe(res => {
      this.roles = res;
    });
  }

  selectedRoleValue(event) {
    this.displaySelectedRole = event.value;
  }

  // check user permission and show dialog box
  // this is only for Site admin as per Jira ticket OHS-711
  checkPermission() {
    if (this.authService.decodedToken.role === 'Site Admin') {
      if (this.displaySelectedRole === 'Site Admin') {
        this.confirmModal = false;
        return false;
       } else if (this.displaySelectedRole === 'Regular') {
         this.confirmModal = true;
         return true;
       }
    } else {
      return null;
    }
  }

  dontDownGrade() {
    this.checkPermission();
    this.confirmModal = false;
    this.closeWindows = true;
    this.dialog.closeAll();
  }

  continueToUpgrade() {
    this.confirmModal = true;
    this.closeWindows = true;
  }

  assignPermission() {
    this.model.email = this.userEmailAddress;
    this.model.role = this.permission;
    this.userPermission.userPermission(this.model).subscribe(
      res => {
        this.userLocationCount = res.headers.get('locationcount');

        this.userRoleExists = res.headers.get('userinrole');
        if (this.userRoleExists) {
          this.alertify.warning(this.userRoleExists);
        }
        this.genericAccountRestrictedRole = res.headers.get('genericaccount');
        if (this.genericAccountRestrictedRole) {
          this.alertify.warning(this.genericAccountRestrictedRole);
        }
        if (res.status === 200) {
          this.confirmModal = false;
          this.alertify.success(`Role of ${this.permission} assigned to ${this.userEmailAddress}`);
          this.dialog.closeAll();
        }
        this.ngOnInit();
       }, error => {
         this.alertify.error('Something went wrong!');
       }
     );
   }

   getAllRoles() {
     this.ngOnInit();
     this.userPermission.getRoles();
   }
}
